import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** C0-LOOK P3 sample (render/masterLook.ts): master ramp set, saturation cap, selective coloured outlines on scenery. */
    masterLook: boolean;
  }
}

defineSetting({
  key: 'masterLook',
  default: false,
  order: 102,
  menu: {
    group: 'visual',
    label: 'ชุดสีหลักและเส้นขอบสี (ทดลอง)',
    note: () => 'รวมสีของต้นไม้ อาคาร และของในฉากให้เป็นชุดเดียวกัน ลดสีจัด และให้เส้นขอบเป็นสีเข้มของวัตถุเอง',
    changed: () => void window.dispatchEvent(new Event('c0look-scenery')),
  },
});
